import { Balance } from '@/@data'
import { MainStatisticChartCard } from '@/components/finance/balance/MainStatisticChartCard'
import { StatisticSummaryCards } from '@/components/finance/balance/StatisticSummaryCards'
import { useRouteQuery } from '@/hooks'
import { Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'

export const BalanceCompanyDetailCurrent = ({ dataCompare, idUrl }: { dataCompare: any, idUrl: any }) => {
  const { searchQuery } = useRouteQuery()

  const paramsStatistic = useMemo(() => {
    return {
      year: searchQuery.get('month')?.substring(0, 4),
      month: searchQuery.get('month')?.substring(5, 7),
      company_id: idUrl
    }
  }, [searchQuery])

  const { data: dataChartTotalTransactionFees } = useQuery({
    ...Balance.getChartTotalTransactionFees(paramsStatistic),
    enabled: !!idUrl
  })

  return (
    <Grid container spacing={6}>
      <Grid size={{ xs: 12, md: 9 }}>
        <MainStatisticChartCard data={dataChartTotalTransactionFees?.data} dataCompare={dataCompare} />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <StatisticSummaryCards dataCompare={dataCompare} />
      </Grid>
    </Grid>
  )
}
